import {ClaimFilters} from 'Agent/Claims/ducks/claim';
import {map as mapEither} from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {addFilterParameters} from 'Shared/utilities/addFilterParameters';
import {get} from 'Shared/utilities/fetchHelpers';
import {ClaimsApi} from 'Agent/Claims/api/api';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {DataSource} from 'Shared/utilities/DataSourceUtility';
export const claimRootUri = '/api/claims/v1';

const claimsApi = new ClaimsApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

enum CLAIM_STATUS {
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  DENIED = 'DENIED',
}

export default {
  getClaims: (
    agentNumbers: string[],
    isNewYork: boolean,
    encryptedIdentifier: string,
    policyId: string,
    filter?: ClaimFilters,
    source?: string
  ) =>
    get<any>(
      `${claimRootUri}/policies/${policyId}${addFilterParameters({
        agentNumbers,
        isNewYork,
        encryptedIdentifier,
        ...filter,
        eisFlag: Number(source) === DataSource.EIS,
      })}`
    ).then(itemsEither =>
      pipe(
        itemsEither,
        mapEither(items => {
          return {
            currentPageNumber: 0,
            links: [],
            result: items,
            totalCount: items.length,
          };
        })
      )
    ),
};
